
/********************Custom Jquery******************************/

$(document).ready( function(){
  
if( $(".cmtTesimonialsSec").length) {
  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots: true,
    autoplay:true,
    autoplayTimeout:8000,
	smartSpeed:1000,
    responsive:{
        0:{
            items:1
        },
        767:{
            items:1
        },
        899:{
            items:1
        },
      	1023:{
            items:1
        },
      	1279:{
            items:1
        }
    }
  });

}  
  
  
});